<template>
	<div class="home" id="home">
		<div class="nav">
			<div style="display: flex;">
				<div style="display: flex;align-items: center;">
					<div style="display: flex;align-items: center;cursor: pointer;" @click="go('home')" v-if="isWorker">
						<img src="../../public/logo.png" alt="logo" style="width: 50px;height: 50px;" />
						<span style="padding-left: 10px;">智慧林业一体化平台</span>
					</div>
					<div style="display: flex;align-items: center;" v-if="!isWorker">
						<img src="../../public/logo.png" alt="logo" style="width: 50px;height: 50px;" />
						<span style="padding-left: 10px;">智慧林业一体化平台</span>
					</div>
					<div style="padding-left: 30px;cursor: pointer;">
						<el-dropdown  trigger="click" @command="roleChange" v-if="loginTypeName">
							<span class="el-dropdown-link" style="color: #fff;">
							{{loginTypeName}}<i class="el-icon-arrow-down el-icon--right"></i>
							</span>
							<el-dropdown-menu slot="dropdown">
							<el-dropdown-item v-for="item in menuBox" :key="item.index" :command="item.index">{{item.loginTypeName}}</el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown>
					</div>
				</div>
			</div>
			<div style="display: flex;align-items: center;">
				<div style="display: flex;margin-right: 64px;" v-if="isWorker">
					<el-button 
						type="text"
						class="topButton"
						:class="$store.state.activateMenu==3?'activeBtn':''"
						@click="go(3)" 
						v-if="$store.state.user.menuIds.indexOf(3) > -1"
					>审批管理<i class="point" v-if="counts.spgl&&counts.spgl==true"></i></el-button>
					<el-button 
						type="text" 
						class="topButton" 
						:class="$store.state.activateMenu==1?'activeBtn':''"
						@click="go(1)"
						v-if="$store.state.user.menuIds.indexOf(1) > -1"
					>林木溯源<i class="point" v-if="counts.lmsy&&counts.lmsy==true"></i></el-button>
					<el-button 
						type="text" 
						class="topButton" 
						:class="$store.state.activateMenu==7?'activeBtn':''"
						@click="go(7)"
						v-if="$store.state.user.menuIds.indexOf(7) > -1"
					>巡护执法<i class="point" v-if="counts.xhzf&&counts.xhzf==true"></i></el-button>
					<el-button 
						type="text" 
						class="topButton" 
						:class="$store.state.activateMenu==8?'activeBtn':''"
						@click="go(8)"
						v-if="$store.state.user.menuIds.indexOf(8) > -1"
					>林长履职</el-button>
					<el-button 
						type="text" 
						class="topButton" 
						:class="$store.state.activateMenu==9?'activeBtn':''"
						@click="go(9)"
						v-if="$store.state.user.menuIds.indexOf(9) > -1"
					>核查任务</el-button>
					<el-button 
						type="text" 
						class="topButton" 
						:class="$store.state.activateMenu==5?'activeBtn':''"
						@click="go(5)"
						v-if="$store.state.user.menuIds.indexOf(5) > -1"
					>一张图</el-button>
					<el-button
						type="text" 
						class="topButton" 
						:class="$store.state.activateMenu==4?'activeBtn':''"
						@click="go(4)"
						v-if="$store.state.user.menuIds.indexOf(4) > -1"
					>信息管理 </el-button>
					<el-button 
						type="text" 
						class="topButton" 
						:class="$store.state.activateMenu==6?'activeBtn':''"
						@click="go(6)"
						v-if="$store.state.user.menuIds.indexOf(6) > -1"
					>平台管理</el-button>
				</div>
				<!-- 普通用户 -->
				<div style="display: flex;" v-if="!isWorker">
					<el-button
						type="text" 
						class="topButton" 
						:class="$store.state.activateMenu == 1? 'activeBtn' : '' "
						@click="go(1)"
						v-if="$store.state.user.menuIds.indexOf(1) > -1"
					>信息管理 </el-button>
					
					<el-button
						type="text" 
						class="topButton" 
						:class="$store.state.activateMenu == 41? 'activeBtn' : '' "
						@click="goPage('/SJGS/myReserve')"
						v-if="$store.state.user.menuIds.indexOf(41) > -1"
					>我的申请 </el-button>
					
					<el-button
						type="text" 
						class="topButton" 
						:class="$store.state.activateMenu == 42? 'activeBtn' : '' "
						@click="goPage('/SJGS/oneMap')"
						v-if="$store.state.user.menuIds.indexOf(42) > -1"
					>一张图 </el-button>
					<!-- <el-button
						type="text" 
						class="topButton" 
						:class="$store.state.activateMenu == 2? 'activeBtn' : '' "
						@click="go(2)"
						v-if="$store.state.user.menuIds.indexOf(2) > -1"
					>用户中心 </el-button> -->
					<!-- <el-button
						type="text" 
						class="topButton" 
						:class="$store.state.activateMenu == 2? 'activeBtn' : '' "
						@click="go(3)"
						v-if="$store.state.user.menuIds.indexOf(3) > -1"
					>消息管理 </el-button> -->
				</div>
				<el-badge :value="badgeNum" v-if="badgeNum != 0">
					<el-tooltip effect="light" content="通知中心" placement="bottom">
						<i class="el-icon-bell" @click="drawerDialogClick" style="cursor: pointer;"></i>
					</el-tooltip>
				</el-badge>
				<div v-else>
					<el-tooltip
						style="vertical-align: middle;"
						effect="light"
						content="通知中心"
						placement="bottom"
						popper-class="myToolTip"
					>
						<i class="el-icon-bell" @click="drawerDialogClick"></i>
					</el-tooltip>
				</div>
				<el-dropdown @command="handleCommand">
					<div style="display: flex;align-items: center;margin-left: 16px;">
						<el-avatar :size="40" :src="src"></el-avatar>
					</div>
					<el-dropdown-menu slot="dropdown">
						<el-dropdown-item disabled>{{user.userName}}</el-dropdown-item>
						<el-dropdown-item command="1" divided>个人中心</el-dropdown-item>
						<el-dropdown-item command="2">退出登录</el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
				
				<!-- <span class="userName"  @click="goUserCenter" style="margin-left: 16px">{{user.userName}}</span> -->
			</div>
		</div>
		<el-drawer
			title="通知列表"
			:visible.sync="drawerDialog"
			:modal="false"
			direction="rtl"
			size="20%"
			:close-on-click-modal="false"
		>
			<el-scrollbar style="height:100%">
				<div
					class="drawer-list"
					v-for="(item, index) in dataInfos"
					:key="index"
					v-if="dataInfos.length > 0"
					@click="lookDetail(item)"
				>
					<div class="drawer-time">{{ item.CreationTime }}</div>
					<div class="drawer-text">{{ item.Content }}</div>
					<el-divider></el-divider>
				</div>
				<div v-else>暂无通知</div>
			</el-scrollbar>
		</el-drawer>
		<!-- 通知详情 -->
		<el-dialog title="通知详情" :visible.sync="noticeDialogVisible" width="30%">
			<p>{{ Content }}</p>
			<span slot="footer" class="dialog-footer">
				<el-button type="success" @click="noticeDialogVisible = false">确 定</el-button>
			</span>
		</el-dialog>
		<div style="display: flex;height: calc(100vh - 60px);">
			<BaseAside :approveCountList="approveCountList" ref="baseAside" class="base-aside" v-show="$store.state.activateMenuUrl !== '/home' && $store.state.activateMenuUrl !== '/userCenter' && !($store.state.activateMenu == 5 && $store.state.user.staffType == 0)" />
			<div class="content">
				<router-view @go-notice="goNotice" />
			</div>
			<iframe id="iframe" ref="iframe" :frameborder="0" src="https://lyapp.gispai.com/dataDoc" v-show="false"></iframe>
		</div>
	</div>
</template>

<script>
/**
 * @description 首页
 */
import { setLocalStorage, getLocalStorage, removeLocalStorage } from '../utils/localStorage';
import { GetMessageCount, GetMessage, SetRead, GetMessageCount2, GetMessage2, SetRead2 ,UpdateUserLoginType} from '@/api/user.js';
import PopConfirm from '../components/PopConfirm/src/index.vue';
import {GetSpglCount,GetPromptFlags} from '@/api/Ordered'
import {GetLmsyCount} from '@/api/TransportLedger'
import {GetLhzfCount} from '@/api/Event'
import {GetMyMapToken} from '@/api/staff'
import store from '../store';
import BaseAside from './user/baseAside.vue';
export default {
	name: 'home',
	components: {
		PopConfirm,
		BaseAside
	},
	computed: {
		user() {
			return this.$store.state.user;
		}
	},
	data() {
		return {
			src: 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png',
			badgeNum: 0,
			drawerDialog: false,
			dataInfos: [],
			Content: '',
			noticeDialogVisible: false,
			menuBox: [],
			loginTypeName: '',
			isWorker: false,
			approveCountList:[],//审批模块数量提示
			counts:{},//导航栏各模块是否显示小圆点
		};
	},
	async mounted() {
		this.$nextTick(() => {
			let isWorker = JSON.parse(localStorage.getItem('isWorker'));
			this.isWorker = isWorker
			if (isWorker == true) {
				let token = JSON.parse(localStorage.getItem('user-token-gispai'))
				GetMyMapToken(token).then(res=>{
					if(res.data.state>0){
						const iframeWin = this.$refs['iframe'].contentWindow
						let user_gispai = JSON.parse(JSON.parse(localStorage.getItem("user_gispai")))
						if(res.data.state==2){
							localStorage.setItem('user-token-gispai', JSON.stringify(res.data.data));
							user_gispai.Token = res.data.data
          					localStorage.setItem('user_gispai',JSON.stringify(JSON.stringify(user_gispai)))
							document.getElementById("iframe").onload=()=>{
							   iframeWin.postMessage({user:JSON.stringify(user_gispai)},'*')
							};
						}else{
							document.getElementById("iframe").onload=()=>{
							   iframeWin.postMessage({user:JSON.stringify(user_gispai)},'*')
							};
						} 
					}
				})
				
				GetMessageCount().then(res => {
					if (res.data.state == 1) {
						this.badgeNum = parseInt(res.data.data);
					}
				});
				
				GetPromptFlags().then(res=>{
					if(res.data.state==1){
						this.counts = res.data.data
					}
				})
				
				// this.$router.push('/index');
				// if (this.$store.state.stateTagsList.length > 0) {
				// 	this.$router.push(this.$store.state.stateTagsList[this.$store.state.stateTagsList.length - 1].url);
				// } else {
				// 	this.$router.push('/index');
				// }
			} else {
				this.menuBox = JSON.parse(localStorage.getItem('user')).menuBox
				this.loginTypeName = JSON.parse(localStorage.getItem('user')).loginTypeName
				GetMessageCount2().then(res => {
					if (res.data.state == 1) {
						this.badgeNum = parseInt(res.data.data);
					}
				});
				// this.$router.push('/userCenter');
				// if (this.$store.state.stateTagsList.length > 0) {
				// 	this.$router.push(this.$store.state.stateTagsList[this.$store.state.stateTagsList.length - 1].url);
				// } else {
				// 	this.$router.push('/userCenter');
				// }
			}
			this.getAllMeaage();
		});
	},
	methods: {
		handleCommand(command) {
			switch (command) {
				case "1":
					this.goUserCenter()
					break;
				case "2":
					this.handleLogOutConfirm()
					break;
				default:
					break;
			}
		},
		// 跳转
		go(id){
			if(id == "home") {
				this.activeID = null
				this.$router.push('/home');
				return
			}
			// 默认加载有权限的第一个菜单
			let { menuData, menuData2 } = require('@/utils/menuData')
			let m = ""
			if(this.isWorker) {	
				m = menuData.find(x => x.id == id)
			}else {
				m = menuData2.find(x => x.id == id)
			}
			// 获取各类审核提示
			if(id==3){
				GetSpglCount().then(res=>{
					if(res.data.state==1){
						this.approveCountList = res.data.data
					}
				})
			}
			
			if(id==1&&this.isWorker){
				GetLmsyCount().then(res=>{
					if(res.data.state==1){
						this.approveCountList = res.data.data
					}
				})
			}
			
			if(id==7){
				GetLhzfCount().then(res=>{
					if(res.data.state==1){
						this.approveCountList = res.data.data
					}
				})
			}
			this.$refs.baseAside.initMenu(id)
			for (let i = 0; i < m.children.length; i++) {
				if(this.$store.state.user.menuIds.indexOf(m.children[i].id) > -1) {
					console.log("push",m.children[i].url)
					this.$router.push(m.children[i].url)
					break;
				}
			}
		},
		goNotice(){
			this.$refs.baseAside.initMenu(4)
		},
		// 设计公司路由跳转
		goPage(url){
			this.$router.push(url)
		},
		// 切换角色
		roleChange(e){
			let index = parseInt(e) - 1
			let params = {
				loginType:parseInt(this.menuBox[index].loginType),
				loginTypeId:parseInt(this.menuBox[index].loginTypeId)
			}
			UpdateUserLoginType(params).then(res => {
				if (res.data.state == 1) {
					this.loginTypeName = this.menuBox[index].loginTypeName
					let userInfo = JSON.parse(localStorage.getItem('user'))
					userInfo.menuIds = res.data.data
					userInfo.loginTypeName = this.menuBox[index].loginTypeName
					setLocalStorage('user', userInfo);
					this.$refs.baseAside.initMenu()
					this.$router.push('/userCenter');
					// this.$refs.tags.getList()
				}
			});
		},
		// 查看通知详情
		lookDetail(item) {
			this.Content = item.Content;
			this.noticeDialogVisible = true;
		},
		drawerDialogClick() {
			this.setMessage();
			this.drawerDialog = true;
		},
		// 个人中心
		goUserCenter() {
			this.$router.push('/userCenter');
		},
		getAllMeaage() {
			let isWorker = JSON.parse(localStorage.getItem('isWorker'));
			if (isWorker == true) {
				GetMessage({ pageIndex: 1, pageSize: 10000, readStatus: -1 }).then(res => {
					if (res.data.state == 1) {
						let data = JSON.parse(res.data.data);
						this.dataInfos = data.Lis;
					}
				});
			} else {
				GetMessage2({ pageIndex: 1, pageSize: 10000, readStatus: -1 }).then(res => {
					if (res.data.state == 1) {
						let data = JSON.parse(res.data.data);
						this.dataInfos = data.Lis;
					}
				});
			}
		},
		// 设置全部通知为已读
		setMessage() {
			let isWorker = JSON.parse(localStorage.getItem('isWorker'));
			if (isWorker == true) {
				SetRead().then(res => {
					if (res.data.state == 1) {
						this.badgeNum = 0;
					}
				});
			} else {
				SetRead2().then(res => {
					if (res.data.state == 1) {
						this.badgeNum = 0;
					}
				});
			}
		},
		// 退出登录
		handleLogOutConfirm() {
			this.$router.push('/');
			localStorage.clear();
			// removeLocalStorage('user-token');
		}
	}
};
</script>
<style lang="less" scoped>
.home {
	width: 100vw;
	height: 100vh;
	background-color: #f3f4f8;
	display: flex;
	flex-direction: column;
	overflow: hidden;
	.topButton{
		position: relative;
		color:#fff;
		font-size: 16px;
		margin-right: 28px;
		.point {
			position: absolute;
			top: 8px;
			right:-10px;
			background-color: #f56c6c;
			border-radius: 50%;
			display: inline-block;
			width: 10px;
			height: 10px;
		}
	}
	
	.activeBtn {
		position: relative;
		&::before {
			content: '';
			width: 100%;
			height: 2px;
			background: #fff;
			position: absolute;
			bottom: 0px;
		}
	}
	.nav {
		// position: fixed;
		// top: 0px;
		// left: 0px;
		padding: 0 20px;
		width: 100%;
		height: 60px;
		line-height: 60px;
		font-size: 20px;
		background-color: #3ea563;
		color: #fff;
		display: flex;
		justify-content: space-between;
		.myToolTip {
			top: 60px !important;
		}
		.userName {
			color: #fff;
			overflow:hidden;
			text-overflow:ellipsis;
			white-space: nowrap;
			font-size: 14px;
			cursor: pointer;
			max-width: 130px;
			display: block;
			line-height: 64px;
		}
	}
	.content {
		// position: fixed;
		flex: 1;
		// top: 60px;
		// left: 201px;
		// width: calc(100% - 201px);
		// height: calc(100vh - 60px);
		background-color: #fff;
		margin: 15px;
		box-sizing: border-box;
	}
	.el-divider--horizontal {
		margin: 12px 0;
	}

	.drawer-list {
		line-height: 22px !important;
		.drawer-time {
			font-size: 12px;
			color: #888;
		}
		.drawer-text {
			font-size: 14px;
			color: #505050;
			margin-top: 5px;
		}
	}
	/deep/.el-drawer__body {
		overflow: auto;
		padding: 0 20px;
	}
	/deep/.el-drawer {
		top: 75px !important;
		height: 100% !important;
	}
	/deep/ .el-form-item {
		margin-bottom: 10px;
	}
	/deep/.el-button--small, .el-button--small.is-round {
			padding: 8px!important;
	}
	/deep/.el-dialog__header {
		background-color: #67c23a!important;
	}
}
</style>
<style lang="less">
.el-badge__content {
	top: 17px !important;
}
</style>
